import { useNavigate } from "react-router-dom";
import { LoadingState } from "@/components/borrowers/LoadingState";
import { PageHeader } from "@/components/borrowers/PageHeader";
import { BorrowersList } from "@/components/borrowers/BorrowersList";
import { useLoans } from "@/hooks/useLoans";

const Borrowers = () => {
  const navigate = useNavigate();
  const { data: loans, isLoading } = useLoans();

  if (isLoading) {
    return (
      <div className="container mx-auto p-6">
        <PageHeader onBack={() => navigate(-1)} />
        <LoadingState />
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <PageHeader onBack={() => navigate(-1)} />
      <BorrowersList loans={loans || []} />
    </div>
  );
};

export default Borrowers;